import { render, staticRenderFns } from "./recDialog.vue?vue&type=template&id=c2d5a34c"
import script from "./recDialog.vue?vue&type=script&lang=js"
export * from "./recDialog.vue?vue&type=script&lang=js"
import style0 from "./recDialog.vue?vue&type=style&index=0&id=c2d5a34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports